import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import Button from './_button.js'
import DateTime from './_date-time.js'
import PriceBoostMarketContent from './_price-boost-market-content.js'

export default {
  name: 'PriceBoostCoupon',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '16px',
        style: {
          flexDirection: 'column',
          padding: '8px 0 0 0',
          _mobile_padding: '8px',
        },
      },
    },
    eventsGroupContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    sportNameTitle: {
      configSet: Text,
      configValues: {
        container: {
          display: 'flex',
          padding: '0 8px',
          height: '40px',
          alignItems: 'center',
        },
      },
    },
    eventsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '1px',
        style: {
          flexDirection: 'column',
          overflow: 'hidden',
        },
      },
    },
    eventContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '0 8px',
        },
      },
    },
    eventHeaderContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          height: '47px',
          alignItems: 'center',
        },
      },
    },
    eventNameButton: {
      configSet: Button,
      configValues: {
        enableAHref: true,
        style: {
          base: {
            flexDirection: 'column',
          },
        },
      },
    },
    startTimeLabel: {
      configSet: Text,
      configValues: {},
    },
    startTimeFormat: {
      configSet: DateTime,
      configValues: {
        showTodayAndTomorrowLabels: true,
      },
    },
    eventNameLabel: {
      configSet: Text,
      configValues: {},
    },
    marketContent: {
      configSet: PriceBoostMarketContent,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
